import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PerimeterIcon extends BaseIcon {
  getChildren = () => [
    <g>
      <path fill={ this.getColor() } d="M8,2.29A5.71,5.71,0,1,1,2.29,8,5.71,5.71,0,0,1,8,2.29M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Z"/>
      <g>
        <circle fill='none' cx="8" cy="8" r="4"/>
        <path fill={ this.getColor() }
              d="M8,12V11a3.06,3.06,0,0,0,.85-.12l.28,1A4,4,0,0,1,8,12Zm-1.13-.16a4.36,4.36,0,0,1-1-.47l.54-.85a2.84,2.84,0,0,0,.77.36Zm3.29-.47-.54-.85a2.88,2.88,0,0,0,.65-.56l.75.66A4.1,4.1,0,0,1,10.16,11.37ZM5,10.62a4,4,0,0,1-.62-1l.91-.41a2.79,2.79,0,0,0,.46.71Zm6.66-1-.91-.41A3,3,0,0,0,11,8.43l1,.14A3.7,3.7,0,0,1,11.64,9.66ZM4,8.57A4.08,4.08,0,0,1,4,7.43l1,.14a3.1,3.1,0,0,0,0,.86Zm6.93-1a3,3,0,0,0-.24-.82l.91-.41A3.7,3.7,0,0,1,12,7.43Zm-5.7-.82-.91-.41a4,4,0,0,1,.62-1L5.73,6A3,3,0,0,0,5.27,6.75Zm5-.71a2.88,2.88,0,0,0-.65-.56l.54-.85a4.1,4.1,0,0,1,.86.75ZM6.38,5.48l-.54-.85a4.36,4.36,0,0,1,1-.47l.28,1A2.84,2.84,0,0,0,6.38,5.48Zm2.46-.36A2.94,2.94,0,0,0,8,5V4a4,4,0,0,1,1.13.16Z"/>
      </g>
    </g>
  ]
  getViewBox = () => '0 0 16 16'
}


